import {useMessages} from "i18n";
import {ExpiredLine} from "./LimitWallExpiredNotice.styles";

/**
 * The one line a dead limit-wall link gets on the send screen (kitecorp/transferify-ui#3197): among the
 * panel's notices, over the ordinary composer, which still sends. It says one thing and stops, for the
 * ladder's reason: no repricing, no hint of a better offer. `role="status"` because it appears without
 * the reader acting, under the same accessible name the ladder's expired notice announces itself with.
 */
export function LimitWallExpiredNotice() {
	const {offerLadder} = useMessages();
	return (
		<ExpiredLine role="status" aria-label={offerLadder.expired.regionAria} data-testid="limit-wall-expired">
			{offerLadder.limitWall.expiredNotice}
		</ExpiredLine>
	);
}
